export default "__VITE_ASSET__C$0rgcJH__"